module.exports = "<p>energy-saver-banner works!</p>\n"